import React, { useEffect, useRef, useState } from 'react';
import FlexComponent from '../FlexComponent';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Avatar } from 'primereact/avatar';
import './form.css';
import { ErrorMessage } from 'formik';
import WorkHistoryComponent from './WorkHistoryComponent';

function WorkHistory({ values, errors, touched, handleChange, handleBlur, setFieldValue }) {

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id='workAndIncome'>
            <WorkHistoryComponent values={values} isSecondJob={false} errors={errors} touched={touched} handleBlur={handleBlur} setFieldValue={setFieldValue} />
            <div className='inputContainerDiv' style={{ textAlign: 'start', width: "40%", padding: "1rem" }}>
                <Dropdown
                    id='where_are_the_documents_submitted'
                    value={values.do_you_have_second_job}
                    options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                    ]}
                    style={{ width: '100%' }}
                    onChange={(e) => handleChange({
                        target: {
                            name: `do_you_have_second_job`,
                            value: e.value
                        }
                    })}
                    showClear={values.do_you_have_second_job}
                    onBlur={handleBlur}
                    placeholder='Do you have a second Job?'
                />
            </div>
            {values.do_you_have_second_job === "Yes" && <WorkHistoryComponent values={values} isSecondJob={true} errors={errors} touched={touched} handleBlur={handleBlur} setFieldValue={setFieldValue} />}
        </div>
    );
}

export default WorkHistory;